import { getLocale } from './locales';

export const formatDate = (
    locale: string,
    dateString?: string,
    format: 'dayMonthYear' | 'monthYear' = 'dayMonthYear',
): string => {
    if (!dateString) {
        return '';
    }
    const mappedLocale = getLocale(locale);
    const date = new Date(dateString);
    const month = new Intl.DateTimeFormat(mappedLocale, { month: 'short' }).format(date);
    const year = new Intl.DateTimeFormat(mappedLocale, { year: 'numeric' }).format(date);

    if (format === 'monthYear') {
        return `${month} ${year}`;
    }
    const day = new Intl.DateTimeFormat(mappedLocale, { day: '2-digit' }).format(date);

    return `${day} ${month} ${year}`;
};
